export default () => ({
  graphContainer: {
    height: '40vh',
  },
});
